export default __webpack_public_path__ + "static/media/15.4d909661.png";